import { render } from "./XiaoneiOrders.vue?vue&type=template&id=18c6c7ff&scoped=true"
import script from "./XiaoneiOrders.vue?vue&type=script&lang=js"
export * from "./XiaoneiOrders.vue?vue&type=script&lang=js"

import "./XiaoneiOrders.vue?vue&type=style&index=0&id=18c6c7ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c6c7ff"]])

export default __exports__